import React from 'react';
import { Button, Table } from 'react-bootstrap';
import { Link } from 'react-router';
import axios from './../../../constants/axios';
import moment from 'moment';
import DatePicker from 'react-datepicker';

class SaleReturnHome extends React.Component {

   constructor(props) {
      super(props);
      this.state = {
         saleReturns: [],
         startDate: null,
         endDate: null,
      };
   }


   componentDidMount() {
      axios.get('saleReturns/getAllSaleReturns')
         .then((res) => {
            this.setState({
               saleReturns: res.data.results,
               startDate: moment(res.data.startDate),
               endDate: moment(res.data.endDate),
            });
         });
   }

   handleStartDateChange = (date) => {
      this.setState({
         startDate: date
      });
   };

   handleEndDateChange = (date) => {
      this.setState({
         endDate: date
      });
   };

   getInvoicesDateBetween = () => {
      const { startDate, endDate } = this.state;
      if (startDate && endDate) {
         axios.get(`saleReturns/getAllSaleReturns?startDate=${startDate.format('YYYY-MM-DD')}&endDate=${endDate.format('YYYY-MM-DD')}`)
            .then((res) => {
               this.setState({
                  saleReturns: res.data.results,
                  startDate: moment(res.data.startDate),
                  endDate: moment(res.data.endDate),
               });
            });
      }
   };


   render() {
      const { saleReturns } = this.state;
      return (
         <div className="SaleReturnsHome" >
            <h1 >Sale Return Home</h1 >
            <div >
               <DatePicker
                  dateFormat="DD-MM-YYYY"
                  selected={this.state.startDate}
                  placeholderText="Select Start Date"
                  onChange={this.handleStartDateChange} />
               <DatePicker
                  dateFormat="DD-MM-YYYY"
                  selected={this.state.endDate}
                  placeholderText="Select End Date"
                  onChange={this.handleEndDateChange} />
               <Button onClick={() => this.getInvoicesDateBetween()} >Get Invoices</Button >
            </div >

            <Table >
               <thead >
               <tr >
                  <th >#inv Id</th >
                  <th >Contact Name</th >
                  <th >Amount Billed</th >
                  <th >Amount Due</th >
                  <th >Inv Created</th >
                  <th >##</th >
               </tr >
               </thead >
               <tbody >
               {saleReturns.map((saleReturn) => (
                  <tr key={saleReturn.id} >
                     <td >{saleReturn.id}</td >
                     <td >{saleReturn.contact_name}</td >
                     <td >{saleReturn.amount}</td >
                     <td >{saleReturn.amount_due}</td >
                     <td >{saleReturn.created_at}</td >
                     <td >
                        <Link to={`/saleReturn/saleReturnInvoiceDetail/${saleReturn.id}`} >Details</Link >
                        {saleReturn.amount_due !== 0 &&
                        <Link to={`/saleReturn/saleReturnPayment/${saleReturn.id}`} >Pay</Link >
                        }
                     </td >
                  </tr >
               ))}
               </tbody >
            </Table >
         </div >
      );
   }
}


export default SaleReturnHome;



/** WEBPACK FOOTER **
 ** ./src/components/InvoiceManagement/SaleReturn/SaleReturnHome.js
 **/